const ITEMS = [
  "Space to Live. Room to Stay.",
  "Distinctive Residences. Thoughtfully Hosted.",
  "De La Vie Maison · Baker, LA",
  "Heritage · Ascension Parish, LA",
  "Hearthstead Cottage · Baker, LA",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-[#16301f] border-y border-[#16301f] py-4 overflow-hidden"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((text, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display uppercase tracking-[0.25em] text-sm text-[#f7f2e7]/85 px-8">
              {text}
            </span>
            <span aria-hidden="true" className="w-2 h-2 rotate-45 bg-[#c9a227] inline-block shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
